import Link from "@/components/common/Link";
import Image from "@/components/common/Image";
import { useI18n } from "@/common/I18nProvider";

export default function FooterOne() {
  const { messages } = useI18n();
  const footer = messages.footer;
  const common = messages.common;

  return (
    <footer className="footer-section">
      {/* <!-- Golden Bar --> */}
      <div style={{ 
        height: '3px', 
        background: 'linear-gradient(90deg, #c1a360 0%, #d4b870 50%, #c1a360 100%)',
        width: '100%'
      }}></div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>

      <div className="container">
        <div className="row g-5 g-md-4 g-xl-5">
          {/* <!-- Footer Card - Company Info --> */}
          <div className="col-12 col-sm-6 col-md-4 col-xl-5">
            <div className="footer-card me-lg-5">
              {/* <!-- Footer Logo --> */}
              <Link href="/" className="footer-logo mb-4 d-inline-block">
                <Image 
                  className="w-auto h-auto" 
                  src="/assets/img/core-img/logo-w.svg" 
                  alt={common.companyName} 
                  width={1898} 
                  height={1023} 
                  priority
                  style={{ maxHeight: '60px', width: 'auto' }}
                />
              </Link>
              
              {/* <!-- Company Name --> */}
              <h4 className="mb-2" style={{ color: '#0e2f85', fontWeight: '700' }}>
                {common.companyName}
              </h4>
              
              {/* <!-- Slogan --> */}
              <p className="mb-3" style={{ color: '#6c757d', fontSize: '0.95em' }}>
                {common.companyFullName}
              </p>
              
              {/* <!-- Description --> */}
              <p className="mb-4" style={{ color: '#49515B', lineHeight: '1.7' }}>
                {footer.description}
              </p>
              
              {/* <!-- Social Nav --> */}
              <div className="social-nav d-flex gap-3">
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noreferrer"
                  aria-label="Facebook"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--Primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#c1a360';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--Primary)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <i className="ti ti-brand-facebook" style={{ fontSize: '18px' }}></i>
                </a>
                <a 
                  href="https://x.com" 
                  target="_blank" 
                  rel="noreferrer"
                  aria-label="X (Twitter)"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--Primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#c1a360';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--Primary)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <i className="ti ti-brand-x" style={{ fontSize: '18px' }}></i>
                </a>
                <a 
                  href="https://linkedin.com" 
                  target="_blank" 
                  rel="noreferrer"
                  aria-label="LinkedIn"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--Primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#c1a360';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--Primary)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <i className="ti ti-brand-linkedin" style={{ fontSize: '18px' }}></i>
                </a>
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noreferrer"
                  aria-label="Instagram"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--Primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#c1a360';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--Primary)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <i className="ti ti-brand-instagram" style={{ fontSize: '18px' }}></i>
                </a>
              </div>
            </div>
          </div>

          {/* <!-- Footer Card - Pages --> */}
          <div className="col-12 col-sm-6 col-md">
            <div className="footer-card">
              <h5 className="mb-4" style={{ color: 'var(--Primary)', fontWeight: '600' }}>
                {footer.pages}
              </h5>
              <ul className="list-unstyled footer-nav">
                <li><Link href="/">{footer.links.home}</Link></li>
                <li><Link href="/about-us">{footer.links.about}</Link></li>
                <li><Link href="/services">{footer.links.services}</Link></li>
                <li><Link href="/products">{footer.links.products}</Link></li>
                <li><Link href="/contact">{footer.links.contact}</Link></li>
              </ul>
            </div>
          </div>

          {/* <!-- Footer Card - Services --> */}
          <div className="col-12 col-sm-6 col-md">
            <div className="footer-card">
              <h5 className="mb-4" style={{ color: 'var(--Primary)', fontWeight: '600' }}>
                {footer.ourServices}
              </h5>
              <ul className="list-unstyled footer-nav">
                <li><Link href="/services">{footer.serviceLinks.transport}</Link></li>
                <li><Link href="/services">{footer.serviceLinks.oils}</Link></li>
                <li><Link href="/services">{footer.serviceLinks.accessories}</Link></li>
                <li><Link href="/faq">{footer.links.faq}</Link></li>
              </ul>
            </div>
          </div>

          {/* <!-- Footer Card - Information --> */}
          <div className="col-12 col-sm-6 col-md">
            <div className="footer-card">
              <h5 className="mb-4" style={{ color: 'var(--Primary)', fontWeight: '600' }}>
                {footer.information}
              </h5>
              <ul className="list-unstyled footer-nav">
                <li><Link href="/about-us">{footer.links.about}</Link></li>
                <li><Link href="/privacy">{footer.links.privacy}</Link></li>
                <li><Link href="/terms">{footer.links.terms}</Link></li>
                <li><Link href="/faq">{footer.links.faq}</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>

      {/* <!-- Copyright --> */}
      <div className="container">
        <div className="copyright-section text-center py-3">
          <p className="mb-0 copyright" style={{ color: '#49515B', fontSize: '0.95em' }}>
            {common.copyright.replace('{year}', new Date().getFullYear().toString())}
            <br />
            <small style={{ fontSize: "0.85em", opacity: 0.8 }}>
              تصميم وتطوير:{" "}
              <a
                href="https://firstcode.ly"
                target="_blank"
                rel="noreferrer"
                aria-label="شركة الشفرة الأولى للخدمات تقنية المعلومات"
                style={{ color: '#c1a360', textDecoration: 'none' }}
              >
                شركة الشفرة الأولى للخدمات تقنية المعلومات
              </a>
            </small>
          </p>
        </div>
      </div>
    </footer>
  )
}
